var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModalEmojiSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2551",
    "data-name": "Group 2551",
    transform: "translate(-368 -280)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_116",
    "data-name": "Ellipse 116",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(368 280)",
    fill: "#816aaf",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "emoji-happy",
    d: "M12.4.4a12,12,0,1,0,12,12A12,12,0,0,0,12.4.4Zm0,21.5a9.5,9.5,0,1,1,9.5-9.5A9.5,9.5,0,0,1,12.4,21.9ZM9.276,12.087A2.048,2.048,0,0,0,11.15,9.9,2.049,2.049,0,0,0,9.275,7.713,2.049,2.049,0,0,0,7.4,9.9,2.049,2.049,0,0,0,9.276,12.087Zm6.249,0A2.049,2.049,0,0,0,17.4,9.9a2.049,2.049,0,0,0-1.875-2.187A2.05,2.05,0,0,0,13.65,9.9,2.05,2.05,0,0,0,15.525,12.087Zm2.3,1.983a.946.946,0,0,0-1.26.4c-.042.083-1.086,1.991-4.165,1.991s-4.114-1.891-4.166-1.99a.938.938,0,0,0-1.674.847c.063.124,1.56,3.017,5.84,3.017s5.776-2.9,5.837-3.019A.932.932,0,0,0,17.826,14.07Z",
    transform: "translate(379.4 291.6)",
    fill: "#816aaf"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalEmojiSmile);
export default __webpack_public_path__ + "static/media/modal-emoji-smile.68f420818dcdf58514ca22ab3fb85bc2.svg";
export { ForwardRef as ReactComponent };